export default __webpack_public_path__ + "static/media/abstract3.30a17b64.svg";